export enum AIChatRole {
  System = 'system',
  User = 'user',
  Assistant = 'assistant',
}

export enum AIChatEntityAction {
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Found = 'found',
}

export enum AIChatEntityType {
  Task = 'task',
  Calendar = 'calendar',
  Incident = 'incident',
  Invoice = 'invoice',
  Rental = 'rental',
  Inquiry = 'inquiry',
  Expense = 'expense',
  Guest = 'guest',
  Extra = 'extra',
  Charge = 'charge',
  Inventory = 'inventory',
  LosDiscount = 'los_discount',
  DiscountCode = 'discount_code',
}

export interface AIChatMessageItem {
  role: AIChatRole
  content: string
  contentHtml?: string
}

export interface AIChatMessageItemWithMetadata extends AIChatMessageItem {
  metadata?: {
    action: AIChatEntityAction
    type: AIChatEntityType
    entity: any
  }[]
}

export interface AIChatItem {
  id: string
  title: string
  length: number
  updatedAt: number
  createdAt: number
}

export interface AIChatHistory {
  id: string
  title: string
  replies: AIChatMessageItemWithMetadata[]
}

// business, casual, playful, thoughtful
export enum AITone {
  Business = 'business',
  Casual = 'casual',
  Playful = 'playful',
  Thoughtful = 'thoughtful',
}

export interface AISuggestionRequestPayload {
  account: string
  type: 'rental_description'
  id: string
  count: number
  tone: AITone
  length: number
  convert?: 'html'
}
export interface AiGuestSummaryResponse {
  guestSummary: string
}
